/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import {
  Services,
  Portfolios,
  Advantages,
  Testimonials,
} from "json/landingPageData";
import Header from "parts/Header";
import Hero from "parts/Hero";
import Service from "parts/Service";
import Portfolio from "parts/Portfolio";
import Advantage from "parts/Advantage";
import Testimonial from "parts/Testimonial";
import Discuss from "parts/Discuss";
import Footer from "parts/Footer";
import productionImage from "../assets/images/production.jpg";

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <Hero />
        <Service data={Services} />
        <Portfolio data={Portfolios} />
        <div
          className="bg-cover bg-center py-12"
          style={{
            backgroundImage: `url(${productionImage})`,
            backgroundAttachment: "fixed", // Makes the background image fixed while scrolling
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div className="flex justify-center gap-8 text-white">
            <div className="text-center">
              {/* icons */}
              <div className="text-4xl font-bold">1350</div>
              <div className="text-lg mt-2">Working Hours</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold">70+</div>
              <div className="text-lg mt-2">Completed Projects</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold">50</div>
              <div className="text-lg mt-2">Happy Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold">12</div>
              <div className="text-lg mt-2">Awards Received</div>
            </div>
          </div>
        </div>
        <Advantage data={Advantages} />
        <Testimonial data={Testimonials} />
        <Discuss />
        <Footer />
      </>
    );
  }
}
